import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactSection = () => {
  return (
    <>
          <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  Contact Us
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT CARDS */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">

            {/* PHONE */}
            <div className="contact-card">
              <div className="icon">
                <FaPhoneAlt />
              </div>
              <h3>Quick Contact</h3>
              <a href="tel:+919529697070">+91 9529697070</a>
              <a href="tel:+919552937070">+91 9552937070</a>
            </div>

            {/* EMAIL */}
            <div className="contact-card">
              <div className="icon">
                <FaEnvelope />
              </div>
              <h3> Email</h3>
              <a href="mailto:booking@aaradhyatravels99.com">
                booking@aaradhyatravels99.com
              </a>
            </div>

            {/* ADDRESS */}
            <div className="contact-card">
              <div className="icon">
                <FaMapMarkerAlt />
              </div>
              <h3>Our Address</h3>
              <p>
                <b>Aaradhya Travels</b><br />
                Near RMD College, Opp. Chaudhary Parking,<br />
                Warje, Pune - 411058
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2714.6577649950773!2d73.78479837519102!3d18.49408328259439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDI5JzM4LjciTiA3M8KwNDcnMTQuNSJF!5e1!3m2!1sen!2sin!4v1779795412849!5m2!1sen!2sin"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </section>

      {/* STYLES */}
      <style jsx>{`
        .page-header {
          background: linear-gradient(135deg, #0a0a0a, #1a0000);
          padding: 60px 20px;
          text-align: center;
          color: #fff;
        }

        .page-header h1 {
          color: #FFB100;
          font-size: 38px;
          font-weight: 700;
        }

        .page-header p {
          color: #ccc;
          margin-top: 8px;
        }

        .contact-section {
          background: #0f0f0f;
          padding: 60px 0;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 25px;
        }

        .contact-card {
          background: #111;
          border: 1px solid #FFB100;
          border-radius: 14px;
          padding: 25px;
          text-align: center;
          transition: 0.3s;
          box-shadow: 0 8px 20px rgba(255, 0, 0, 0.12);
        }

        .contact-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 28px rgba(255, 0, 0, 0.25);
        }

        .icon {
          font-size: 28px;
          color: #FFB100;
          margin-bottom: 10px;
        }

        .contact-card h3 {
          color: #FFB100;
          margin-bottom: 10px;
        }

        .contact-card a,
        .contact-card p {
          color: #ddd;
          font-size: 14px;
          display: block;
          margin: 6px 0;
          text-decoration: none;
        }

        .contact-card a:hover {
          color: #ff4d4d;
        }

        .map-section {
          width: 100%;
          height: 450px;
          border-top: 2px solid #8b0000;
        }

        .map-section iframe {
          width: 100%;
          height: 100%;
          border: 0;
          filter: grayscale(10%) contrast(110%);
        }
      `}</style>
    </>
  );
};

export default ContactSection;